
declare global {
    interface NuxtApp {
        $apiError: (message: string) => void,
        $notFoundError:() => void,
        $forbiddenError:() => void,
    }
}

export default defineNuxtPlugin(() => {
    return {
      provide: {
        apiError(message? :string){
            const error_msg = message || 'エラーが発生しました。お手数ですが最初からやり直してください。';
            throw createError({message:error_msg,statusCode:500,fatal:true});
        },
        notFoundError() {
            throw createError({ statusCode:404,fatal:true});
        },
        forbiddenError() {
            const error_msg = "アクセスが許可されていません"
            throw createError({message:error_msg,statusCode:403,fatal:true});
        }
      }
    }
})
